import React from "react";
import { Col, Row, CardBody, Label } from "reactstrap";
import { DebouncedFunc } from "lodash";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { MessageFilterTableDtoStatusEnum } from "generated/apiMessages";

interface NotificationFilterProps {
  debounceFn: DebouncedFunc<(value: any) => void>;
}

const optionState = [
  { label: "READ", value: MessageFilterTableDtoStatusEnum.Readed },
  { label: "NO READ", value: MessageFilterTableDtoStatusEnum.NoReaded },
];

const NotificationsFilter: React.FC<NotificationFilterProps> = ({
  debounceFn,
}) => {
  const { t } = useTranslation("translation", { keyPrefix: "NOTIFICATIONS" });
  const { control } = useFormContext();

  return (
    <React.Fragment>
      <CardBody className="border border-dashed border-end-0 border-start-0">
        <Row>
          <Col sm={4} className="col-xxl-1">
            <div className="d-flex gap-1 flex-wrap">
              <button type="button" className="btn btn-primary w-100">
                {" "}
                <i className="ri-equalizer-fill me-1 align-bottom"></i>
                {t("LAYOUT:FILTERS")}
              </button>
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col sm={5}>
            <Label htmlFor="" className="form-label">
              {t("DETAILS:FILTERS:SEARCH")}
            </Label>
            <div className={"search-box me-2 mb-2 d-inline-block col-12"}>
              <Controller
                name="search"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <input
                    id="search"
                    className="form-control"
                    placeholder={`${t("DETAILS:FILTERS:SEARCH")}...`}
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                      debounceFn(e.target.value);
                    }}
                  />
                )}
              />
              <i className="bx bx-search-alt search-icon"></i>
            </div>
          </Col>
          <Col sm={4}>
            <div className="search-box me-2 mb-2 d-inline-block col-12">
              <Label htmlFor="" className="form-label">
                {t("DETAILS:FILTERS:STATUS")}
              </Label>
              <Controller
                name="status"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <Select
                    {...field}
                    options={[{ value: "", label: `ALL` }, ...optionState]}
                    styles={{
                      option: (provided: any, state: any) => ({
                        ...provided,
                        color: state.data.value === "ALL" ? "#a9a9a9" : "black",
                        backgroundColor: state.isSelected ? "#f0f0f0" : "white",
                      }),
                      singleValue: (provided: any, state: any) => ({
                        ...provided,
                        color: state.data.value === "ALL" ? "#a9a9a9" : "black",
                      }),
                    }}
                  />
                )}
              />
            </div>
          </Col>
          <Col sm={4} className="col-xxl-4">
            <div></div>
          </Col>
        </Row>
      </CardBody>
    </React.Fragment>
  );
};
export default NotificationsFilter;
